module.exports = __webpack_public_path__ + "static/media/loading.c90cded3.svg";